module.exports = __webpack_public_path__ + "static/media/Iphone-X outline.0948adb4.png";